'use strict';
angular.module('schoolLinqApp').factory('outstandingCheckService', [
	'$http',
	'$q',
	function ($http, $q) {
		const endpoint = '/api/outstandingcheck';

		function searchChecks(filter) {
			return $http.get(endpoint + '/inquiry', {
				params: {
					FromDT: filter.fromDT,
					ToDT: filter.toDT,
					FromCheck: filter.fromCheck,
					ToCheck: filter.toCheck,
					Source: filter.source,
					BankId: filter.bankId,
					IncludeChecks: filter.includeChecks,
					IncludeEFTs: filter.includeEFTs,
					IncludeACHs: filter.includeACHs,
					IncludeVoids: filter.includeVoids,
					IncludeVoidsOnly: filter.includeVoidsOnly,
				},
			});
		}

		function addCheck(check) {
			return $http.put(endpoint, check);
		}

		function updateCheck(check) {
			return $http.post(endpoint, check);
		}

		function reconcile(items) {
			return $http.post(endpoint + '/reconcile', { items: items });
		}

		function deleteCheck(id) {
			return $http.delete(endpoint, { params: { id: id } });
		}

		function getCalendarYears(bankId) {
			return $http.get(endpoint + '/getcalendaryears', {
				params: { bankId: bankId },
			});
		}

		function getClearDates(bankId, year) {
			return $http.get(endpoint + '/getcleardates', {
				params: { bankId: bankId, year: year },
			});
		}

		function getNextEftNumber(bankId) {
			return $http.get(endpoint + '/nexteftnumber', {
				params: { bankId: bankId },
			});
		}

		function search(filter) {
			return $http.get(endpoint + '/search', {
				params: {
					recordTypes: filter.recordTypes,
					getProcessed: filter.getProcessed,
					getVoided: filter.getVoided,
					BankId: filter.BankId,
					ClearedDT: filter.clearedDT,
					getManualEntries: filter.getManualEntries,
					paymentDateFrom: filter.paymentDateFrom,
					paymentDateTo: filter.paymentDateTo,
					ExcludeCcSummary: filter.excludeCcSummary,
				},
			});
		}

		function voidCheck(checkIds, voidDate, reinstateInvoices, includesPaymentCardCheck) {
			return $http.put(endpoint + '/void', {
				CheckIds: checkIds,
				VoidDate: voidDate,
				ReinstateInvoices: reinstateInvoices,
				IncludesPaymentCardCheck: includesPaymentCardCheck,
			});
		}

		function getItemsForBankRecon(bankId, statementDate) {
			return $http.get(endpoint + '/getItemsForBankRecon', {
				params: { bankId: bankId, statementDate: statementDate },
			});
		}

		function getCardFundSummaryChecks(ids) {
			return $http.get(endpoint + '/cardFundSummaryChecks', {
				params: { ids: ids },
			});
		}

		function getVirtualCardChecks(ids) {
			return $http.get(endpoint + '/virtualCardChecks', {
				params: { ids: ids },
			});
		}

		function getCreditCardChecks(ids) {
			return $http.get(endpoint + '/creditCardChecks', {
				params: { ids: ids },
			});
		}

		return {
			searchChecks: searchChecks,
			addCheck: addCheck,
			updateCheck: updateCheck,
			reconcile: reconcile,
			deleteCheck: deleteCheck,
			getCalendarYears: getCalendarYears,
			getClearDates: getClearDates,
			getNextEftNumber: getNextEftNumber,
			search: search,
			voidCheck: voidCheck,
			getItemsForBankRecon: getItemsForBankRecon,
			getCardFundSummaryChecks: getCardFundSummaryChecks,
			getVirtualCardChecks: getVirtualCardChecks,
			getCreditCardChecks: getCreditCardChecks,
		};
	},
]);
